import './App.css';

function App() {
    return <div className="App">
        <h1 className="headline">
            Come back later to see what I have prepared for you
        </h1>
    </div>;
}

export default App;
